import { render, staticRenderFns } from "./documentation.vue?vue&type=template&id=a6730bf4&scoped=true&"
import script from "./documentation.vue?vue&type=script&lang=js&"
export * from "./documentation.vue?vue&type=script&lang=js&"
import style0 from "./documentation.vue?vue&type=style&index=0&id=a6730bf4&prod&scoped=true&lang=css&"
import style1 from "./documentation.vue?vue&type=style&index=1&id=a6730bf4&prod&lang=css&"
import style2 from "./documentation.vue?vue&type=style&index=2&id=a6730bf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6730bf4",
  null
  
)

export default component.exports